import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@z-components/atoms/Button';
import ProProfileDetails from './ProProfileDetails';
import styles from './ProProfile.module.scss';

import { ProProfilePro } from '../types';
import type { InternalBlogPostItem } from 'modules/marketing-pages/marketing-page.types';

interface Props {
  featureFlags: { isReviewsQAEnabled: boolean };
  internalBlogPosts: Array<InternalBlogPostItem>;
  jobTypeId?: string;
  onRequestClicked: () => void;
  pro: ProProfilePro;
  setJobTypeTitle: (jobTypeId: string) => void;
}

const ProProfile: FC<Props> = ({
  onRequestClicked,
  pro,
  featureFlags,
  internalBlogPosts,
  jobTypeId,
  setJobTypeTitle,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <div className={styles['pro-profile-content-wrapper']}>
        <ProProfileDetails
          featureFlags={featureFlags}
          internalBlogPosts={internalBlogPosts}
          jobTypeId={jobTypeId}
          user={pro}
          setJobTypeTitle={setJobTypeTitle}
        />
      </div>
      <div className={styles['cta-container']}>
        <Button
          className="z-btn-primary-compact"
          onClick={onRequestClicked}
          text={t('users:profile.findPro')}
        />
      </div>
    </>
  );
};

export default ProProfile;
